'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Select2BaseColumn2 = require('./Select2BaseColumn');

var _Select2BaseColumn3 = _interopRequireDefault(_Select2BaseColumn2);

var _odataUri = require('../../utils/odata-uri');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnumColumn = function (_Select2BaseColumn) {
	_inherits(EnumColumn, _Select2BaseColumn);

	function EnumColumn() {
		_classCallCheck(this, EnumColumn);

		return _possibleConstructorReturn(this, (EnumColumn.__proto__ || Object.getPrototypeOf(EnumColumn)).apply(this, arguments));
	}

	_createClass(EnumColumn, [{
		key: 'displayValue',
		value: function displayValue(value) {
			var enums = this.api.init().enums;
			var targetEnum = enums && this.options.dataType && enums[this.options.dataType];
			if (targetEnum) {
				var item = targetEnum.find(function (x) {
					return x.id === value || x.value == value;
				});
				if (item) {
					return item.text;
				}
			}
			return value;
		}
	}, {
		key: 'createEditor',
		value: function createEditor(value, id) {
			var values = this.column.enumValues();
			var options = values.map(function (v) {
				return '<option value="' + v.value + '" ' + (v.value === value ? 'selected="selected"' : '') + '>' + v.text + '</option>';
			}).join('');
			return '<select class="table-input">' + options + '</select>';
		}
	}, {
		key: 'createFilter',
		value: function createFilter() {
			var values = this.api.init().enums[this.options.dataType] || [];
			var options = values.map(function (v) {
				return '<option value="' + v.id + '">' + v.text + '</option>';
			}).join('');
			return '<div class="input-group"><select class="form-control table-filter">\n<option value="">' + this.getFilterAllText() + '</option>' + options + '</select></div>';
		}
	}, {
		key: 'buildFilterExpression',
		value: function buildFilterExpression(fieldName, columnFilter) {
			return _odataUri.filters.equals(fieldName, columnFilter);
		}
	}]);

	return EnumColumn;
}(_Select2BaseColumn3.default);

exports.default = EnumColumn;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/EnumColumn.js
// module id = 1121
// module chunks = 1